
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"64","height":"80","ry":"8","fill":"#fff"}}),_c('path',{attrs:{"d":"M20.84 37.68h2.37v-1.76h-2.13l.61-4.45H19.8l-.61 4.45H15.3l.61-4.45h-1.89l-.61 4.45h-2.37v1.76h2.16l-.83 5.92h-2.32v1.71h2.11l-.59 4.53h1.89l.61-4.53h3.87l-.59 4.53h1.89l.56-4.53h2.43V43.6h-2.16zm-6.56 5.92l.77-5.92h3.92l-.83 5.92zm22.27-8.11c-1.41 0-2.32.75-3.09 1.87-.43-1.44-1.47-1.87-2.53-1.87-1.41 0-2.29.85-3.04 1.95l-.16-1.65H26v14.05h2.05V38.93c.77-1.2 1.57-1.68 2.45-1.68 1.01 0 1.09.72 1.09 2.51v10.08h2.08V38.93c.77-1.2 1.6-1.68 2.45-1.68 1.01 0 1.09.72 1.09 2.51v10.08h2.05V39.39c0-3.23-1.36-3.89-2.72-3.89zm15.17-5.62v7.31c-.96-1.09-2.16-1.68-3.79-1.68-3.44 0-5.49 3.12-5.49 7.33 0 4.37 1.68 7.31 5.36 7.31 1.52 0 2.93-.67 3.97-2.13l.21 1.84h1.97V30.13zm-3.2 7.44c1.31 0 2.43.67 3.2 1.81v6.99c-.77 1.17-1.87 2.24-3.47 2.24-2.21 0-3.39-1.87-3.39-5.52 0-3.71 1.33-5.52 3.65-5.52z"}})])
          )
        }
      }
    